import { useCallback, useEffect, useState } from "react";
import { AdminLayout } from "../../components/Layouts";
import { api, readUser, fmt, errMsg } from "../../lib/api";

const EMPTY_NEW = { full_name: "", username: "", email: "", phone: "", password: "", role: "member", sponsor_code: "" };

export default function AdminUsers() {
  const user = readUser();
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [notice, setNotice] = useState("");
  const [showCreate, setShowCreate] = useState(false);
  const [newUser, setNewUser] = useState(EMPTY_NEW);
  const [createNotice, setCreateNotice] = useState({ ok: false, msg: "" });

  const load = useCallback(async () => {
    const r = await api.get("/admin/users", { params: { search } });
    setRows(r.data);
  }, [search]);
  useEffect(() => { load().catch(() => {}); }, [load]);

  async function viewUser(id) {
    const r = await api.get(`/admin/users/${id}`);
    setSelected(r.data);
  }
  async function toggleActive(u) {
    try { await api.put(`/admin/users/${u.id}`, { active: !u.active }); load(); setNotice(""); } catch (e) { setNotice(errMsg(e)); }
  }
  async function adjust(id, amount, note) {
    try { await api.put(`/admin/users/${id}`, { balance_adjustment: Number(amount), adjustment_note: note || "admin adjustment" }); if (selected) viewUser(id); load(); } catch (e) { setNotice(errMsg(e)); }
  }
  async function createUser(e) {
    e.preventDefault();
    setCreateNotice({ ok: false, msg: "" });
    try {
      await api.post("/admin/users", newUser);
      setCreateNotice({ ok: true, msg: `Kullanıcı oluşturuldu: ${newUser.email}` });
      setNewUser(EMPTY_NEW);
      setShowCreate(false);
      load();
    } catch (e) { setCreateNotice({ ok: false, msg: errMsg(e) }); }
  }

  return (
    <AdminLayout user={user} active="Kullanıcılar">
      <section className="admin-panel">
        <div className="admin-panel-title">
          <div><span className="eyebrow">YÖNETİM</span><h2>Kullanıcılar</h2></div>
          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
            <input data-testid="admin-user-search" placeholder="Arama (ad / e-posta / kullanıcı adı)" value={search} onChange={(e) => setSearch(e.target.value)} className="search-input" />
            <button className="btn btn-accent" onClick={() => setShowCreate(!showCreate)} data-testid="admin-user-create-toggle">
              {showCreate ? "Kapat" : "+ Yeni Üye Ekle"}
            </button>
          </div>
        </div>
        {notice && <div className="error" data-testid="admin-users-notice">{notice}</div>}
        {createNotice.msg && !showCreate && <div className={createNotice.ok ? "success" : "error"} data-testid="admin-user-create-notice">{createNotice.msg}</div>}

        {showCreate && (
          <form onSubmit={createUser} className="pkg-form" style={{ marginBottom: 20 }}>
            <label>Ad Soyad<input data-testid="admin-new-fullname" value={newUser.full_name} onChange={(e) => setNewUser({ ...newUser, full_name: e.target.value })} required /></label>
            <label>Kullanıcı Adı<input data-testid="admin-new-username" value={newUser.username} onChange={(e) => setNewUser({ ...newUser, username: e.target.value })} required /></label>
            <label>E-posta<input data-testid="admin-new-email" type="email" value={newUser.email} onChange={(e) => setNewUser({ ...newUser, email: e.target.value })} required /></label>
            <label>Telefon<input data-testid="admin-new-phone" value={newUser.phone} onChange={(e) => setNewUser({ ...newUser, phone: e.target.value })} required /></label>
            <label>Geçici Şifre<input data-testid="admin-new-password" type="text" value={newUser.password} onChange={(e) => setNewUser({ ...newUser, password: e.target.value })} required minLength={8} /></label>
            <label>Rol<select data-testid="admin-new-role" value={newUser.role} onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}>
              <option value="member">Üye</option>
              <option value="admin">Yönetici</option>
            </select></label>
            <label className="full-row">Sponsor Referans Kodu <span className="optional">opsiyonel</span><input data-testid="admin-new-sponsor" value={newUser.sponsor_code} onChange={(e) => setNewUser({ ...newUser, sponsor_code: e.target.value })} /></label>
            {createNotice.msg && showCreate && <div className={createNotice.ok ? "success" : "error"} data-testid="admin-user-create-form-notice" style={{ gridColumn: "1 / -1" }}>{createNotice.msg}</div>}
            <button className="btn btn-accent" data-testid="admin-new-submit">Üyeyi Oluştur</button>
          </form>
        )}

        <div className="table-wrap">
          <table className="admin-users-table">
            <thead><tr><th>Ad Soyad</th><th>Kullanıcı</th><th>E-posta</th><th>Referans</th><th>Bakiye</th><th>Durum</th><th>Rol</th><th>İşlem</th></tr></thead>
            <tbody>
              {rows.map((u, i) => (
                <tr key={u.id} data-testid={`admin-user-${i}`}>
                  <td data-label="Ad Soyad">{u.full_name}</td>
                  <td data-label="Kullanıcı">@{u.username}</td>
                  <td data-label="E-posta">{u.email}</td>
                  <td data-label="Referans" className="hash">{u.referral_code}</td>
                  <td data-label="Bakiye">${fmt(u.balance)}</td>
                  <td data-label="Durum"><span className={`status ${u.active ? "confirmed" : "rejected"}`}>{u.active ? "Aktif" : "Pasif"}</span></td>
                  <td data-label="Rol">{u.role}</td>
                  <td data-label="İşlem"><div className="mobile-table-actions">
                    <button className="table-action approve" data-testid={`admin-view-user-${i}`} onClick={() => viewUser(u.id)}>Detay</button>
                    <button className="table-action reject" data-testid={`admin-toggle-user-${i}`} onClick={() => toggleActive(u)}>{u.active ? "Pasif" : "Aktif"}</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
          {!rows.length && <div className="table-empty">Kullanıcı bulunamadı.</div>}
        </div>
      </section>

      {selected && (
        <section className="admin-panel">
          <div className="admin-panel-title">
            <div><span className="eyebrow">DETAY</span><h2>{selected.user.full_name}</h2></div>
            <button className="btn btn-light" onClick={() => setSelected(null)} data-testid="admin-user-close">Kapat</button>
          </div>
          <div className="profile-grid">
            <div><span>E-posta</span><strong>{selected.user.email}</strong></div>
            <div><span>Bakiye</span><strong>${fmt(selected.user.balance)}</strong></div>
            <div><span>Referans Kodu</span><strong>{selected.user.referral_code}</strong></div>
            <div><span>Depozito Referansı</span><strong>{selected.user.deposit_reference}</strong></div>
            <div><span>Sponsor</span><strong className="hash">{selected.user.sponsor_id || "—"}</strong></div>
            <div><span>Durum</span><strong>{selected.user.active ? "Aktif" : "Pasif"}</strong></div>
          </div>
          <AdjustForm id={selected.user.id} onSubmit={adjust} />
          <h4 style={{ marginTop: 24 }}>Paketler</h4>
          <div className="table-wrap">
            <table><thead><tr><th>Paket</th><th>Başlangıç</th><th>Birikmiş</th><th>Durum</th></tr></thead>
              <tbody>{selected.user_packages.map((p, i) => (<tr key={i}><td>{p.package_name}</td><td>{new Date(p.start_date).toLocaleDateString("tr-TR")}</td><td>${fmt(p.accumulated_production)}</td><td>{p.status}</td></tr>))}</tbody>
            </table>
          </div>
          <h4 style={{ marginTop: 24 }}>Son 10 İşlem</h4>
          <div className="table-wrap">
            <table><thead><tr><th>Tarih</th><th>Tür</th><th>Tutar</th><th>Sonra</th></tr></thead>
              <tbody>{selected.transactions.slice(0, 10).map((t, i) => (<tr key={i}><td>{new Date(t.date).toLocaleString("tr-TR")}</td><td>{t.type}</td><td>${fmt(t.amount)}</td><td>${fmt(t.balance_after)}</td></tr>))}</tbody>
            </table>
          </div>
        </section>
      )}
    </AdminLayout>
  );
}

function AdjustForm({ id, onSubmit }) {
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  return (
    <form className="deposit-form" style={{ marginTop: 16 }} onSubmit={(e) => { e.preventDefault(); onSubmit(id, amount, note); setAmount(""); setNote(""); }}>
      <label>Bakiye Düzeltmesi (+/−)
        <input data-testid="admin-adjust-amount" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="örn: 25 veya -10" required />
      </label>
      <label>Not<input data-testid="admin-adjust-note" value={note} onChange={(e) => setNote(e.target.value)} /></label>
      <button className="btn btn-accent" data-testid="admin-adjust-submit">Uygula</button>
    </form>
  );
}
